export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/account',
    /* internal name: '/account' */
    /* no component */
    children: [
      {
        path: ':slug',
        name: '/account/[slug]',
        component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug].vue'),
        children: [
          {
            path: 'announcements',
            /* internal name: '/account/[slug]/announcements' */
            /* no component */
            children: [
              {
                path: '',
                name: '/account/[slug]/announcements/',
                component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/announcements/index.vue'),
                /* no children */
              },
              {
                path: ':id',
                /* internal name: '/account/[slug]/announcements/[id]' */
                /* no component */
                children: [
                  {
                    path: 'edit',
                    name: '/account/[slug]/announcements/[id]/edit',
                    component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/announcements/[id]/edit.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'new',
                name: '/account/[slug]/announcements/new',
                component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/announcements/new.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'audit-log',
            /* internal name: '/account/[slug]/audit-log' */
            /* no component */
            children: [
              {
                path: '',
                name: '/account/[slug]/audit-log/',
                component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/audit-log/index.vue'),
                /* no children */
                meta: {
                  "requiresAuth": true,
                  "requiresRole": [
                    "ACCOUNT_EDITOR",
                    "ACCOUNT_ADMIN"
                  ]
                }
              }
            ],
          },
          {
            path: 'dashboard',
            name: '/account/[slug]/dashboard',
            component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/dashboard.vue'),
            /* no children */
            meta: {
              "requiresAuth": true
            }
          },
          {
            path: 'incidents',
            /* internal name: '/account/[slug]/incidents' */
            /* no component */
            children: [
              {
                path: '',
                name: '/account/[slug]/incidents/',
                component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/incidents/index.vue'),
                /* no children */
                meta: {
                  "requiresAuth": true,
                  "requiresRole": [
                    "ACCOUNT_VIEWER",
                    "ACCOUNT_EDITOR",
                    "ACCOUNT_ADMIN"
                  ]
                }
              },
              {
                path: ':id',
                name: '/account/[slug]/incidents/[id]',
                component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/incidents/[id].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'maintenance-windows',
            /* internal name: '/account/[slug]/maintenance-windows' */
            /* no component */
            children: [
              {
                path: '',
                name: '/account/[slug]/maintenance-windows/',
                component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/maintenance-windows/index.vue'),
                /* no children */
              },
              {
                path: ':id',
                /* internal name: '/account/[slug]/maintenance-windows/[id]' */
                /* no component */
                children: [
                  {
                    path: 'edit',
                    name: '/account/[slug]/maintenance-windows/[id]/edit',
                    component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/maintenance-windows/[id]/edit.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'new',
                name: '/account/[slug]/maintenance-windows/new',
                component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/maintenance-windows/new.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'monitors',
            /* internal name: '/account/[slug]/monitors' */
            /* no component */
            children: [
              {
                path: '',
                name: '/account/[slug]/monitors/',
                component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/monitors/index.vue'),
                /* no children */
              },
              {
                path: ':id',
                /* internal name: '/account/[slug]/monitors/[id]' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/account/[slug]/monitors/[id]/',
                    component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/monitors/[id]/index.vue'),
                    /* no children */
                  },
                  {
                    path: 'edit',
                    name: '/account/[slug]/monitors/[id]/edit',
                    component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/monitors/[id]/edit.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'new',
                name: '/account/[slug]/monitors/new',
                component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/monitors/new.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'monthly-reports',
            /* internal name: '/account/[slug]/monthly-reports' */
            /* no component */
            children: [
              {
                path: '',
                name: '/account/[slug]/monthly-reports/',
                component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/monthly-reports/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'settings',
            /* internal name: '/account/[slug]/settings' */
            /* no component */
            children: [
              {
                path: 'alert-management',
                name: '/account/[slug]/settings/alert-management',
                component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/settings/alert-management.vue'),
                /* no children */
                meta: {
                  "requiresAuth": true,
                  "requiresRole": [
                    "ACCOUNT_ADMIN",
                    "ACCOUNT_EDITOR"
                  ]
                }
              },
              {
                path: 'branding',
                name: '/account/[slug]/settings/branding',
                component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/settings/branding.vue'),
                /* no children */
                meta: {
                  "requiresAuth": true,
                  "requiresRole": [
                    "ACCOUNT_ADMIN"
                  ]
                }
              }
            ],
          },
          {
            path: 'status-pages',
            /* internal name: '/account/[slug]/status-pages' */
            /* no component */
            children: [
              {
                path: '',
                name: '/account/[slug]/status-pages/',
                component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/status-pages/index.vue'),
                /* no children */
              },
              {
                path: ':id',
                /* internal name: '/account/[slug]/status-pages/[id]' */
                /* no component */
                children: [
                  {
                    path: 'edit',
                    name: '/account/[slug]/status-pages/[id]/edit',
                    component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/status-pages/[id]/edit.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'new',
                name: '/account/[slug]/status-pages/new',
                component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/account/[slug]/status-pages/new.vue'),
                /* no children */
              }
            ],
          }
        ],
        meta: {
          "requiresAuth": true
        }
      }
    ],
  },
  {
    path: '/accounts',
    name: '/accounts',
    component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/accounts.vue'),
    /* no children */
  },
  {
    path: '/admin',
    name: '/admin',
    component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/admin.vue'),
    children: [
      {
        path: 'accounts',
        name: '/admin/accounts',
        component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/admin/accounts.vue'),
        /* no children */
        meta: {
          "requiresSuperAdmin": true
        }
      },
      {
        path: 'dashboard',
        name: '/admin/dashboard',
        component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/admin/dashboard.vue'),
        /* no children */
        meta: {
          "requiresSuperAdmin": true
        }
      },
      {
        path: 'settings',
        /* internal name: '/admin/settings' */
        /* no component */
        children: [
          {
            path: 'branding',
            name: '/admin/settings/branding',
            component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/admin/settings/branding.vue'),
            /* no children */
            meta: {
              "requiresAuth": true,
              "requiresSuperAdmin": true
            }
          }
        ],
      },
      {
        path: 'users',
        name: '/admin/users',
        component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/admin/users.vue'),
        /* no children */
        meta: {
          "requiresAuth": true,
          "requiresAccountAdminUsers": true
        }
      }
    ],
    meta: {
      "requiresAuth": true
    }
  },
  {
    path: '/forgot-password',
    name: '/forgot-password',
    component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/forgot-password.vue'),
    /* no children */
    meta: {
      "public": true,
      "requiresAuth": false
    }
  },
  {
    path: '/help',
    name: '/help',
    component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/help.vue'),
    /* no children */
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/login.vue'),
    /* no children */
    meta: {
      "public": true,
      "requiresAuth": false
    }
  },
  {
    path: '/login/2fa',
    name: '/login.2fa',
    component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/login.2fa.vue'),
    /* no children */
    meta: {
      "public": true,
      "requiresAuth": false
    }
  },
  {
    path: '/reset-password',
    name: '/reset-password',
    component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/reset-password.vue'),
    /* no children */
    meta: {
      "public": true,
      "requiresAuth": false
    }
  },
  {
    path: '/set-password',
    name: '/set-password',
    component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/set-password.vue'),
    /* no children */
    meta: {
      "public": true,
      "requiresAuth": false
    }
  },
  {
    path: '/status',
    /* internal name: '/status' */
    /* no component */
    children: [
      {
        path: ':accountSlug',
        /* internal name: '/status/[accountSlug]' */
        /* no component */
        children: [
          {
            path: ':pageSlug',
            name: '/status/[accountSlug]/[pageSlug]',
            component: () => import('/var/www/html/scala-watch/apps/ui/src/pages/status/[accountSlug]/[pageSlug].vue'),
            /* no children */
            meta: {
              "public": true,
              "requiresAuth": false
            }
          }
        ],
      }
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

